import React, { useEffect, useState } from 'react'
import { getAxiosResponse, postAxiosResponse, putAxiosResponse } from '../../services/authApiRoutes/APImethods';
import APIUrls from '../../services/APIUrls';
import {updateDepartment, updateSourceLanguage, updateTargetLanguage, updateProjectContentType, updateProjectWorkflow, updateProjectFollowers, updateStatus, updateAssets} from '../../redux/reducers/ProjectInfoSlice';
import { projectCreationStepFilter } from '../../redux/reducers/ProjectCreationStepSlice';
import { useParams } from 'react-router-dom';
import { getTimeStamp, timeStamp, transformBlankToNull } from '../../services/Util';
import { useSelector, useDispatch } from "react-redux";
import { updateProjectInfoValidation } from '../../redux/reducers/ProjectInfoValidationSlice';
import { updateProjectInfo, updateNextStepEvent } from '../../redux/reducers/ProjectInfoSlice';
import { updateProjectRules } from "../../redux/reducers/DynamicAssetSlice";
import { useNavigate } from 'react-router-dom';
import { confirmAlert } from 'react-confirm-alert';
import { useTranslation } from 'react-i18next';
import Constants from '../../Constants';
import { getSelectedAssets, getSelectedAssetKeys, isSegmentationModeEnabled } from '../../services/IntegrationUtil'
import { dateConvertToTimeStamp } from "../../services/Util";
import { setTreeLoading } from "../../redux/reducers/TreeSlice";
import $ from 'jquery';
import SuccessMessage from '../../components/SuccessMessage'
import { updateCanSubmitTranslation, updateReadyForValidation, updateValidationErrors} from '../../redux/reducers/AsyncAssetUploadSlice';
import { handleError } from '../../services/authApiRoutes/APImethods';
import { updateTargetLanguage as updateCreateProjectTargetLanguage } from '../../redux/reducers/CreateProjectTargetLanguageSlice';

const projectCreationSteps = ["Source Material Step 1", "Source Material Step 2", "Upload Image Step", "Language and Reference Material",
	"Project Information", "Translation Request", "Workflow Step 1", "Workflow Step 2", "Project Summary", "Finish And Request Translation"];

export const ProjectFooter = () => {
	const param = useParams();
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const { t } = useTranslation();
	const translate = t;
	const [isEligibleForPutCall, setEligibleForPutCall] = useState(false);
	const [readyToMoveNext, setReadyToMoveNext] = useState(false);
	const [message, setMessage] = useState(Constants.BLANK);
	const [initiateCancelOrSaveExitProject, setInitiateCancelOrSaveExitProject] = useState(false);
	const [updatedProjectInfo, setUpdatedProjectInfo] = useState(null);
	const projectInfoConfiguration = useSelector((reduxStore) => reduxStore.project_info_configuration_slice).value;
	const asyncAssetUploadInfo = useSelector(reduxStore => reduxStore.asset_upload_background).value;	
	const setProjectInfoValidationToRedux = (type, value) => {
		dispatch(updateProjectInfoValidation({type: type, value: value}));
	}
	const urlParams = new URLSearchParams(window.location.search);
    const oldTargetLanguage = useSelector(reduxStore => reduxStore.old_target_language)?.value
	const projectCreationStep = useSelector((projectCreationStepSlice) => projectCreationStepSlice.project_creation_step).value;
	const sourceLanguageRedux = useSelector((reduxStore) => reduxStore.source_language_for_project_creation).value;
	const targetLanguageRedux = useSelector((reduxStore) => reduxStore.target_language_for_project_creation).value;
	const SelectDepartmentRedux = useSelector((reduxStore) => reduxStore.select_department_for_project_creation).value;
	const projectData = useSelector((reduxStore) => reduxStore.project_info).value;
	const bidRequest = useSelector((reduxStore) => reduxStore.bid_request).value
	const contentTypeRedux = useSelector((reduxStore) => reduxStore.content_type_for_project_creation).value
	const projectWorkflowRedux = useSelector((reduxStore) => reduxStore.initialized_project_workflows).value.resource;
	const projectFollowersRedux = useSelector((reduxStore) => reduxStore.project_followers).followersCollection
	const bidRequestRedux = useSelector((reduxStore) => reduxStore.bid_request).value
	const source = useSelector((reduxStore) => reduxStore.source_files).value
	const dispatchFinalDataToRedux = (type, value) => {		
		dispatch(updateProjectInfo({type: type, value: value}));
	}	
	const projectRules = useSelector(reduxStore => reduxStore.dynamic_asset).projectRules;
	const dynamicContacts = useSelector(reduxStore => reduxStore.dynamic_asset).contacts;
	const selectedTreeData = useSelector(reduxStore => reduxStore.tree_structure).selectedTreeData
	const custBootstrapDataRedux = useSelector(store => store.customer_bootstrap_data).value;
	const projectAssetType = useSelector(redux => redux.asset_type_for_project_creation).value;
	const treeValueRedux = useSelector((redux) => redux.tree_structure).treeValue;	
	const isMultiVendorProject = (projectData?.targetLanguages?.length > 1 && (projectData?.translationType ==='MULTI_VENDOR' || projectData?.translationPreferences?.length > 1));
	const projectType = urlParams.get('projectType');
	const errorData = useSelector((reduxStore) => reduxStore.project_info_validation_slice).value;
	const userTimeZone = custBootstrapDataRedux?.user?.timeZone;

	useEffect(() => {
		if (isEligibleForPutCall) {
			if (!(projectCreationStep === "Project Information" || projectCreationStep === "Translation Request")) {
				let newProjectData={...projectData}
				if(newProjectData.name ===""){
					newProjectData = {...newProjectData,'name':'Project-'+projectData.id};
				}
				if(newProjectData?.bidDueDate){
				 newProjectData={...newProjectData,'bidDueDate':newProjectData?.bidDueDate?.utcTimestamp?getTimeStamp(newProjectData?.bidDueDate?.utcTimestamp):timeStamp(newProjectData?.bidDueDate?.dateWithTime?newProjectData?.bidDueDate?.dateWithTime:newProjectData?.bidDueDate,userTimeZone)}
				}
				if(newProjectData?.deliveryDueDate){
					newProjectData={...newProjectData,'deliveryDueDate':newProjectData?.deliveryDueDate?.utcTimestamp? getTimeStamp(newProjectData?.deliveryDueDate?.utcTimestamp):timeStamp(newProjectData?.deliveryDueDate?.dateWithTime?newProjectData?.deliveryDueDate?.dateWithTime:newProjectData?.deliveryDueDate,userTimeZone)}
				}
				if(newProjectData?.bidSelectDeadlineDate){
					newProjectData={...newProjectData,'bidSelectDeadlineDate':newProjectData?.bidSelectDeadlineDate?.utcTimestamp?getTimeStamp(newProjectData?.bidSelectDeadlineDate?.utcTimestamp):timeStamp(newProjectData?.bidSelectDeadlineDate?.dateWithTime?newProjectData?.bidSelectDeadlineDate?.dateWithTime:newProjectData?.bidSelectDeadlineDate,userTimeZone)}
				}
				putAxiosResponse(APIUrls.PROJECT(param.id), newProjectData)
				.then(res => {
					setEligibleForPutCall(false);
					if (res.data?.statusCodeValue === 200 || res?.data?.status === 'success') {
						let projectResource = transformBlankToNull(res?.data?.data?.resource?.projectResource);
						delete projectResource["projectFollowers"];
						//deleted  this key as it was giving 400 
						if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
						delete projectResource["workspace"]['workspaceMembers']
						}
						projectResource.intendedUse = {"id":projectResource.intendedUse.id,"name":projectResource.intendedUse.name};
						projectResource.targetLanguageList = res.data.data.displayName[0].targetLanguages;
						projectResource.translationType = projectData.translationType;
						projectResource.scanImage = projectData.scanImage;
						setUpdatedProjectInfo(projectResource);
					}
				}).catch(err => {
					setEligibleForPutCall(false);
				});
			}
		}
		if(initiateCancelOrSaveExitProject) {
			let newProjectData={...projectData}
			if(newProjectData?.bidDueDate){
				newProjectData={...newProjectData,'bidDueDate':newProjectData?.bidDueDate?.utcTimestamp?getTimeStamp(newProjectData?.bidDueDate?.utcTimestamp):timeStamp(newProjectData?.bidDueDate?.dateWithTime?newProjectData?.bidDueDate?.dateWithTime:newProjectData?.bidDueDate,userTimeZone)}
			   }
			   if(newProjectData?.deliveryDueDate){
				   newProjectData={...newProjectData,'deliveryDueDate':newProjectData?.deliveryDueDate?.utcTimestamp? getTimeStamp(newProjectData?.deliveryDueDate?.utcTimestamp):timeStamp(newProjectData?.deliveryDueDate?.dateWithTime?newProjectData?.deliveryDueDate?.dateWithTime:newProjectData?.deliveryDueDate,userTimeZone)}
			   }
			   if(newProjectData?.bidSelectDeadlineDate){
				   newProjectData={...newProjectData,'bidSelectDeadlineDate':newProjectData?.bidSelectDeadlineDate?.utcTimestamp?getTimeStamp(newProjectData?.bidSelectDeadlineDate?.utcTimestamp):timeStamp(newProjectData?.bidSelectDeadlineDate?.dateWithTime?newProjectData?.bidSelectDeadlineDate?.dateWithTime:newProjectData?.bidSelectDeadlineDate,userTimeZone)}
			   }
			putAxiosResponse(APIUrls.PROJECT(param.id), newProjectData)
			.then((res) => {
				if(res.data.data.statusCodeValue === 200 || res.data.status === "success") {
					navigate("/dashboard");
				}
			})
		}

		if(projectData?.nextStepEvent && projectData?.nextStepEvent.target === "Translation Request"
                && projectData?.nextStepEvent.action === 'save' ){
            dispatch(updateNextStepEvent({target: projectCreationStep, action : 'move-next'
            }));
            updateProjectAndMoveNext();
        }

	}, [projectData]);

    useEffect(()=>{
        if(updatedProjectInfo != null){
            dispatch(updateProjectInfo(updatedProjectInfo));
			setReadyToMoveNext(true);
        }
    },[updatedProjectInfo]);

    const updateProjectAndMoveNext = async() => {
        let noErrorExists = await updateProjectDetails();
        if (!noErrorExists) {
    	    return;
    	}
    	setEligibleForPutCall(true);
    	moveToNextStep();
    }

	const showNext = (projectCreationStep !== "Source Material Step 1") && (projectCreationStep !== "Workflow Step 1");

	const showCancelAndSaveExit = (projectCreationStep !== "Project Summary")

	const validateProjectTranslationRequest = () => {
		if (projectData.projectVendorType == 'EXTERNAL') {
			if (projectData.deliveryDueDate == null) {
				setProjectInfoValidationToRedux('deliveryDueDate', true)
				return false;
			}
			if (projectData.bidDueDate == null) {
				setProjectInfoValidationToRedux('bidDueDate', true)
				return false;
			}
			if (projectData.bidSelectDeadlineDate === undefined) {
				setProjectInfoValidationToRedux('projectDeliveryDueStatus', true)
				return false;
			}
		}
		if (projectData.projectVendorType == 'EXTERNAL_BIDLESS') {
			if (projectData.deliveryDueDate == null) {
				setProjectInfoValidationToRedux('deliveryDueDate', true)
				return false;
			}
			if (projectData.bidSelectDeadlineDate === undefined) {
				setProjectInfoValidationToRedux('projectDeliveryDueStatus', true)
				return false;
			}
		}
		if (projectData.projectVendorType === 'INTERNAL') {
			if (projectData.deliveryDueDate === null) {
				setProjectInfoValidationToRedux('dileveryDueDate', true)
				return false;
			} else if (projectData.assignment == null) {
				setProjectInfoValidationToRedux('assignment', true)
				return false;
			}
		}
		return true;
	}

	const validateProjectBasicDetails = () => {

		if (projectData.name === '') {
			setProjectInfoValidationToRedux('emptyName', true)
			return false;
		}
		if (projectData.intendedUse === null) {
			setProjectInfoValidationToRedux('emptyIntendedUse', true)
			return false;
		}
		if (projectData?.workspace?.name === null) {
			setProjectInfoValidationToRedux('campaignName', true)
			return false;
		}

		if (projectData?.workspace?.dueDate?.date === null) {
			setProjectInfoValidationToRedux('campaignDate', true)
			return false;
		}

		if (projectData.intendedUse?.id === 0 || projectData.intendedUse == null) {
			setProjectInfoValidationToRedux('emptyIntendedUse', true)
			return false;
		}
		if (projectInfoConfiguration.updateGlossaryPermission === true) {
			if (projectData.projectUpdateGlossary === null) {
				setProjectInfoValidationToRedux('glossaryUpdate', true)
				setProjectInfoValidationToRedux('glossaryStatus', true)
				return false;
			}
			if (projectData.projectUpdateGlossary?.generalGlossary === '' ||
				projectData.projectUpdateGlossary?.generalGlossary === null ||
				projectData.projectUpdateGlossary?.generalGlossary === undefined) {
				setProjectInfoValidationToRedux('glossaryStatus', true)
				return false;
			}
			if (projectData?.projectUpdateGlossary?.termStatusOnCompletion === '' ||
				projectData?.projectUpdateGlossary?.termStatusOnCompletion === null ||
				projectData?.projectUpdateGlossary?.termStatusOnCompletion === undefined
			) {
				setProjectInfoValidationToRedux('glossaryUpdate', true)
				return false;
			}


		}
		if (projectInfoConfiguration.startCampaign === -1) {
			if (projectData.workspace?.name === null || projectData.workspace?.name === '') {
				setProjectInfoValidationToRedux('campaignName', true)
				return false;
			}
			else if (projectData.workspace?.dueDate === null || projectData.workspace?.dueDate.date === null) {
				setProjectInfoValidationToRedux('campaignDate', true)
				return false;
			}

		}
		return true;

	}

	// for dynamic assets
	const syncProjectRules = () => {
		dispatch(setTreeLoading(true));
		let integrationName;
		let isSegModeEnabled
		let syncUrl;
		if (contentTypeRedux == Constants.MARKETOREST) {
			isSegModeEnabled = custBootstrapDataRedux.features["MARKETO_REST_SEGMENTATION_MODE"]
			syncUrl = APIUrls.MARKETO_REST_ASSET_PROJECT_RULE_SYNC(projectData?.id)
			integrationName = Constants.MARKETO_CONTENT_TYPE_DISPLAY
		    setMessage(`Retrieving language segmentation information from ${integrationName}. This may take a few minutes...`)
		} else if (contentTypeRedux == Constants.ELOQUA) {
			isSegModeEnabled = custBootstrapDataRedux.features["ELOQUA_DYNAMIC_CONTENT"]
			syncUrl = APIUrls.ELOQUA_ASSET_PROJECT_RULE_SYNC(projectData?.id)
			integrationName = Constants.ELOQUA_CONTENT_TYPE_DISPLAY
			setMessage(`Retrieving language segmentation information from ${integrationName}. This may take a few minutes...`)
		}
		let isClone = projectData?.clonedFromProjectId !== null;
		let selectedAssets = getSelectedAssetKeys(selectedTreeData, projectRules, projectData.language?.code, contentTypeRedux, isSegModeEnabled, isClone);
		let newSelectedAsset = {marketoAssets: selectedAssets};
		postAxiosResponse(syncUrl, (contentTypeRedux == Constants.MARKETOREST) ? newSelectedAsset : selectedAssets
		).then(res => {
			if (res.data.code === 200) {
				fetchSegmentationModeRequestStatus();
			}
		}).catch(err => {
			dispatch(setTreeLoading(false));
		})
	  }
   
	  let timer;
	  const fetchSegmentationModeRequestStatus = () => {
		const dateTimestamp = dateConvertToTimeStamp();
		let syncUrl;
		if (contentTypeRedux == Constants.MARKETOREST) {
			syncUrl = APIUrls.MARKETO_REST_ASSET_PROJECT_RULE_SYNC(projectData?.id)
		} else if (contentTypeRedux == Constants.ELOQUA) {
			syncUrl = APIUrls.ELOQUA_ASSET_PROJECT_RULE_SYNC(projectData?.id)
		}
		timer = setTimeout(() => {
			getAxiosResponse(syncUrl + `?_=${dateTimestamp}`
			).then(res => {
			if (res.data.code === 200) {
				checkSegmentationModeRequestStatus(res)
			}
			}).catch(err => {
				dispatch(setTreeLoading(false));
			})
		}, 7000)
	  }
   
	  const checkSegmentationModeRequestStatus = (res) => {
		if (res.data.data.syncPending === true) {
		  fetchSegmentationModeRequestStatus();
		} else {
			let ruleUrl;
			if (contentTypeRedux == Constants.MARKETOREST) {
				ruleUrl = APIUrls.MARKETO_REST_ASSET_PROJECT_RULE(projectData?.id)
			} else if (contentTypeRedux == Constants.ELOQUA) {
				ruleUrl = APIUrls.ELOQUA_ASSET_PROJECT_RULE(projectData?.id)
			}
			clearTimeout(timer);
			const dateTimestamp = dateConvertToTimeStamp();
			getAxiosResponse(ruleUrl + `?_=${dateTimestamp}`
			).then((res) => {
			  if (res.data.code === 200) {
		   		const projectRules = transformBlankToNull(res.data.data);
				dispatch(updateProjectRules(projectRules));
				onSegmentationSyncComplete(projectRules);
			  }
			}).catch((err) => {
			  handleError(err);
			  dispatch(setTreeLoading(false));
			});
		}
	  }
   
	  const onSegmentationSyncComplete = (projectRules) => {
		let isClone = projectData?.clonedFromProjectId !== null;
        let isProjectRequest = !!projectData?.projectRequest;
		let assetIds = [];
		let externalRuleIds = [];
		let uniqueProjectRules = [];
		projectRules.map(rule => {
		  assetIds.push(rule.parentAssetId !== null ? rule.parentAssetId : rule.externalAssetId);
		  var externalRuleId = rule.externalRuleId;
		  if (!externalRuleIds.includes(externalRuleId)) {
			externalRuleIds.push(externalRuleId);
			uniqueProjectRules.push(rule);
		  }
		})
   
		var invalidAssetNames = [];
		selectedTreeData.map(asset => {
          if (!assetIds.includes((isClone || isProjectRequest) ? asset.externalId : asset.id)) {
			invalidAssetNames.push(asset.name);
		  }
		})

		let isSegModeEnabled = segmentationFeatureCheck();
		setMessage(Constants.BLANK)

		if (isSegmentationModeEnabled(isSegModeEnabled, projectRules) && invalidAssetNames.length == 0) {
		  //available rules found	
		  uniqueProjectRules =  JSON.parse(JSON.stringify(uniqueProjectRules));
		  uniqueProjectRules.map(rule => {
			let ruleValues = rule.ruleValues;
			if (ruleValues?.length > 0) {
			// sort rule values so that default comes last
			  ruleValues.sort((a, b) => {
				if (a.name == 'Default') {
				  return 1;
				}
				return 0;
			  })
			}
		  })
		  	dispatch(updateProjectRules(uniqueProjectRules));
			dispatch(setTreeLoading(false));
		  	//send to next screen
		  	moveToNextStep();
		} else {
			dispatch(setTreeLoading(false));
			var invalidAssetNamesString = invalidAssetNames.join(Constants.COMMA);
			let segmentationName;
			if (contentTypeRedux == Constants.MARKETOREST) {
				segmentationName = "Marketo"
			} else if (contentTypeRedux == Constants.ELOQUA) {
				segmentationName = "Eloqua"
			}			
		  confirmAlert({
			title: `No Segmentation Found`,
			message: (
			  <p>We were unable to find any {segmentationName} segmentations configured for your selected assets <strong>{invalidAssetNamesString}</strong> Please select different assets and try again.</p>
			),
			buttons: [
			  {
				label: `Accept`,
				onClick: () => {}
			  }
			],
			closeOnEscape: true,
			closeOnClickOutside: false,
			overlayClassName: "delete_overlay",
		  });

		}	
	  }

	const submitProject = (payload) => {
		if(projectData?.projectVendorType === "INTERNAL") {
			getAxiosResponse(APIUrls.INTERNAL_REQUEST(param.id))
			.then((res) => {
				if(res?.data?.code === 200) {
					payload = transformBlankToNull(res.data.data)
					postAxiosResponse(APIUrls.INTERNAL_REQUEST(param.id), payload)
					.then((response) => {
						if(response.data.data.statusCodeValue === 200 || response.data.status === "success") {
							navigate('/project/'+param.id);
						}
					})
				}
			}) 

		} else if(projectData?.projectVendorType === "MACHINE_TRANSLATION") {
			getAxiosResponse(APIUrls.GET_MACHINE_TRANSLATOR_REQUEST(param.id))
			.then((res) => {
				if(res?.data?.code === 200) {
					payload = transformBlankToNull(res.data.data)
					postAxiosResponse(APIUrls.GET_MACHINE_TRANSLATOR_REQUEST(param.id), payload !== null ? payload : {id : null})
					.then((response) => {
						if(response?.data?.data?.statusCodeValue === 200 || response?.data?.status === "success") {
							navigate('/project/'+param.id);
						}
					})
				}
			})
		} else {
			postAxiosResponse(APIUrls.BID_REQUEST_BY_ID(param.id), payload)
			.then((res) => {
				if(res?.data?.data?.statusCodeValue === 200 || res?.data?.status === "success") {
					navigate('/project/'+param.id);
				}
			})
		}
	}
	
	const cancelProjectSubmission = () => {
		dispatch(projectCreationStepFilter(projectCreationStep));
		setTimeout(()=>{
			if($("button").hasClass("submitFocusBtn")){
				$('.submitFocusBtn').trigger('focus')
				$('button.submitFocusBtn').removeClass('submitFocusBtn')
			}
		},200)
	}

	const back = () => {
		if (projectCreationStep === "Project Summary") {
			$("#goNext").removeClass("projectSummary");
		}
		let currentStepIndex = projectCreationSteps.indexOf(projectCreationStep);
		if (currentStepIndex !== 0) {
			let currentStep = projectCreationSteps[currentStepIndex]
			let prevStep;
			if (currentStep === Constants.LANGUAGE_AND_REFERENCE_MATERIAL) {
				if (contentTypeRedux === Constants.ELOQUA && treeValueRedux.scanImgforTranslation) {
					prevStep = projectCreationSteps[currentStepIndex - 1];
				} else {
					prevStep = projectCreationSteps[currentStepIndex - 2];
				}
			} else {
				prevStep = projectCreationSteps[currentStepIndex - 1];
			}
			dispatch(projectCreationStepFilter(prevStep));
		}
		if(projectCreationStep === "Project Information") {
			dispatch(updateCanSubmitTranslation(true));
		}
		setTimeout(()=>{
			$('.left-sidebar.step-list li.locked a').removeClass('clickFocus')
			$('.left-sidebar.step-list li.active a').addClass('clickFocus')
			if($(".left-sidebar.step-list li a").hasClass("clickFocus")){
				if ($('.clickFocus').attr('id')==="sourceMaterial") {
					$('#sourceMaterial').removeAttr('id');
					return;
				} else {
					$('.clickFocus').trigger('focus')
					if (!$('#sourceMaterial').length && !$('.sourceTab').hasClass('clickFocus')) {
						$('.sourceTab').attr('id', 'sourceMaterial');
					}
				}
			 }
		  },1000)
		
	}

	const segmentationFeatureCheck = () => {
		const isSegModeEnabled = contentTypeRedux === Constants.MARKETOREST ? custBootstrapDataRedux?.features?.MARKETO_REST_SEGMENTATION_MODE :
    		contentTypeRedux === Constants.ELOQUA ? custBootstrapDataRedux?.features?.ELOQUA_DYNAMIC_CONTENT : false;
		return isSegModeEnabled;
	}

	const next = async () => {		
		let syncInDb = false;
	    if(projectCreationStep === "Translation Request" && isMultiVendorProject){
            dispatch(updateNextStepEvent({
                target: projectCreationStep,
                action : 'validate'
            }));
            return false;
	    }

		if (projectCreationStep === "Project Summary") {
			$("#goNext").addClass("projectSummary");
		} else {
			$("#goNext").removeClass("projectSummary");
		}

		if (projectCreationStep === "Source Material Step 2" || projectCreationStep === Constants.UPLOAD_IMAGE_STEP) {
			dispatch(updateDepartment({
				"path": null,
				"applicationVersion": null,
				"id": SelectDepartmentRedux.value,
				"name": SelectDepartmentRedux.label,
				"createdDate": null,
				"systemGroup": false
			}))
			dispatch(updateProjectContentType(contentTypeRedux));
			if (projectAssetType === Constants.DYNAMIC) {
				syncProjectRules();
			}
			if(contentTypeRedux === Constants.STANDARD) {
				dispatchFinalDataToRedux('status', 'CONFIGURED_SOURCE_MATERIALS')
				dispatchFinalDataToRedux('statusCode', 'uploaded_source_materials')
			} else {
				dispatchFinalDataToRedux('status', 'CONFIGURED_PROJECT_NAME')
				dispatchFinalDataToRedux('statusCode', 'configured_project_details')
			}
			syncInDb = true;
		}
		if (projectCreationStep === Constants.UPLOAD_IMAGE_STEP) {
			syncInDb = true;
			setEligibleForPutCall(syncInDb);
            setReadyToMoveNext(syncInDb);
		}

		if (projectCreationStep === "Language and Reference Material") {
			if(custBootstrapDataRedux?.features?.ASSET_VALIDATION && selectedTreeData?.length !== 0 && sourceLanguageRedux!== undefined && targetLanguageRedux !== undefined) {
				dispatch(updateReadyForValidation(true));
			} 
			dispatch(updateSourceLanguage(sourceLanguageRedux?.language));
			dispatch(updateTargetLanguage(targetLanguageRedux.map((targetLang) => {
				return (targetLang.language != undefined) ? targetLang.language : targetLang.name;
			})));
			if (contentTypeRedux === Constants.ELOQUA || contentTypeRedux == Constants.MARKETOREST ||
				contentTypeRedux === Constants.BRIGHTCOVE || contentTypeRedux === Constants.PARDOT || 
				contentTypeRedux === Constants.VIDYARD || contentTypeRedux === Constants.UBERFLIP || contentTypeRedux === Constants.EXACTTARGET) {
				let isClone = projectData?.clonedFromProjectId !== null;
				let selectedAssets = getSelectedAssets(contentTypeRedux, selectedTreeData, sourceLanguageRedux, isClone)	
				if(isClone){
					const assetTrg = selectedAssets
					?.filter(data => !oldTargetLanguage?.includes(data?.language))
					?.map(data => data);
				   dispatch(updateAssets(transformBlankToNull(assetTrg)))
				}else{
					dispatch(updateAssets(transformBlankToNull(selectedAssets)));
				}
			    dispatch(updateAssets(transformBlankToNull(selectedAssets)));
				dispatchFinalDataToRedux('assetRules', projectRules);
				let localContacts = []
				dynamicContacts.map(contact => localContacts.push(contact.contact));
				if (contentTypeRedux == Constants.MARKETOREST) {
					dispatchFinalDataToRedux('marketoRestPreviewContactList', localContacts);
				} else if (contentTypeRedux == Constants.ELOQUA) {
					dispatchFinalDataToRedux('eloquaPreviewContactList', localContacts);
				}
			}
			dispatchFinalDataToRedux('status', 'CONFIGURED_SOURCE_MATERIALS')
			dispatchFinalDataToRedux('statusCode', 'uploaded_source_materials')
			syncInDb = true;
		}

		if (projectCreationStep === "Project Information") {
			let noErrorExists = validateProjectBasicDetails();
			if (!noErrorExists) {
				return;
			}
			syncInDb = true;
		}

		if (projectCreationStep === "Translation Request") {
			let noErrorExists = validateProjectTranslationRequest();
			if (!noErrorExists) {
				return;
			}
			syncInDb = true;
		}
		if((projectCreationStep === "Project Information" || projectCreationStep === "Translation Request")){
			let noErrorExists = await updateProjectDetails();
			if (!noErrorExists) {
				return;
			}
			syncInDb = true;
		}

		if(projectCreationStep === "Workflow Step 2") {
			let updatedWorkflowRedux = [...projectWorkflowRedux]
			updatedWorkflowRedux.map((pwresource, pwindex) => {
				let updatedResource = {...pwresource};
				let oldUserGroup = {...updatedResource.userGroup}
				let newUserGroup = {
					id : oldUserGroup.id,
					customer : null,
					createdDate : null,
					name : null,
					deleted : false
				}
				updatedResource.userGroup = newUserGroup;
				updatedWorkflowRedux[pwindex] = updatedResource;
			})
			dispatch(updateProjectWorkflow(transformBlankToNull(updatedWorkflowRedux)));
			dispatchFinalDataToRedux('status', 'CONFIGURED_PROJECT_WORKFLOW')
			dispatchFinalDataToRedux('statusCode', 'configured_project_workflow')
			let followerPayload = [];
			projectFollowersRedux.map((pf) => {
				let follower = {...pf}
				let res = {...follower?.resource};
				let rset = {...res.roleSet}
				rset = follower.roleSet;
				res.roleSet = rset;
				follower.resource = res;
				followerPayload.push({
					path : null,
					applicationVersion : null,
					customerUser : follower?.resource?.customerUser || follower?.resource,
					id : follower.id
				})
			})
			dispatch(updateProjectFollowers(transformBlankToNull(followerPayload)))
			syncInDb = true;
		}

		if(projectCreationStep === "Project Summary") {			
			getPopupDetails();
			syncInDb = true;
		}

		setEligibleForPutCall(syncInDb);
		setReadyToMoveNext(!syncInDb);

			if(urlParams.get("projectAssetType")==='ELOQUA'){
				if (projectData && projectData?.scanImage) {
					let step=projectCreationSteps;
					navigateStepper(step,projectCreationStep)
				}else{
					let step=projectCreationSteps.filter(step=> step !=="Upload Image Step" );
					navigateStepper(step,projectCreationStep)
				}
		}else{
			let step=projectCreationSteps.filter(step=> step !=="Upload Image Step" );
			navigateStepper(step,projectCreationStep)
	}
	}
	const navigateStepper=(step,projectCreationStep)=>{
		let urlIndex=step.indexOf(urlParams.get("step"))
		let stepsIndex=+step.indexOf(projectCreationStep)
		let stepIndex=step.indexOf(projectCreationStep)
		if(+urlIndex===+stepsIndex || urlIndex===-1){
			if(projectCreationStep !== "Project Summary"){
				if(step[step?.length >stepIndex?stepIndex+1:step?.length] ==="Upload Image Step"){
					navigate(`/createProject/${param?.id}?projectAssetType=${urlParams.get("projectAssetType")}&step=${step[3]}${projectType?`&projectType=${projectType}`:""}`)
				}else{
					navigate(`/createProject/${param?.id}?projectAssetType=${urlParams.get("projectAssetType")}&step=${step[step?.length >stepIndex?stepIndex+1:step?.length]}${projectType?`&projectType=${projectType}`:""}`)
				}
			}
	}
   }

	useEffect(() => {
		if(readyToMoveNext) {
			setTimeout(()=>{
				if (projectAssetType !== Constants.DYNAMIC && projectCreationStep !== "Project Summary"  || 
				((projectAssetType === Constants.DYNAMIC && projectCreationStep !== "Source Material Step 2" 
					&& projectCreationStep !== "Project Summary"))) {
					moveToNextStep();
				}
			},1000)		
			
			setTimeout(()=>{
				$('.left-sidebar.step-list li a').removeClass('clickFocus')
				$('.left-sidebar.step-list li.active a').addClass('clickFocus')
				if ($(".projectSummary").length) {
					return;
				} else if($(".left-sidebar.step-list li a").hasClass("clickFocus")){
					$('.clickFocus').trigger('focus')
					$('.sourceTab').attr('id', 'sourceMaterial');
				 }
			  },1000)
		}
	}, [readyToMoveNext])

	const moveToNextStep = () => {
		let currentStepIndex = projectCreationSteps.indexOf(projectCreationStep);
		if (currentStepIndex !== projectCreationSteps.length) {
			let currentStep = projectCreationSteps[currentStepIndex]
			let nextStep;
			if (currentStep === Constants.SOURCE_MATERIAL_STEP_2) {
				if (contentTypeRedux === Constants.ELOQUA && treeValueRedux.scanImgforTranslation) {
					nextStep = projectCreationSteps[currentStepIndex + 1];
				} else {
					nextStep = projectCreationSteps[currentStepIndex + 2];
				}
			} else {
				nextStep = projectCreationSteps[currentStepIndex + 1];
			}
			dispatch(projectCreationStepFilter(nextStep));
		}
	}

	const cancelProjectAndNavigateToDashboard = () => {
		dispatchFinalDataToRedux('status', 'CANCELLED')
		dispatchFinalDataToRedux('statusCode', 'cancelled')
		setInitiateCancelOrSaveExitProject(true);
	}

	const handleNoCancel = () => {
		dispatch(projectCreationStepFilter(projectCreationStep));
		  if($("button").hasClass("btnFocus")){
			$('.btnFocus').trigger('focus')
			$('.btnSave').removeClass('btnFocus')
		  }
		  if($("button").hasClass("cancelFocus")){
			$('.cancelFocus').trigger('focus')
			$('.btnCancel').removeClass('cancelFocus')
		  }
		}

	const cancelProject = () => {
		$('.btnCancel').addClass('cancelFocus')
		setTimeout(() => {
		$("#react-confirm-alert").attr({
			'aria-modal': 'true',
			'role': 'dialog',
			'aria-labelledby':"CancelProject"
		  });
		  $("h1").attr({
			'id': 'CancelProject',
		 });
		}, 200);
		 setTimeout(() => {
			$('#yes-cancel').trigger('focus');
			$(".react-confirm-alert-overlay").on("keydown", function (e) {
				if (e.key === Constants.ESCAPE) {
					if($("button").hasClass("cancelFocus")){
						$('.cancelFocus').trigger('focus')
						$('.btnCancel').removeClass('cancelFocus')
					}
				}
			  });
		}, 600);
		confirmAlert({
			title: `${t('label_cancel_project')}`,
			message: <p>{`${t('cancel_project_confrm_message')}`}</p>,
			buttons: [
			  {
				label: `${t('button_yes')}`,
				id: 'yes-cancel',
				onClick: () => cancelProjectAndNavigateToDashboard(),
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === true){
						e.preventDefault()
						$('#no-cancel').trigger('focus');
					  }
					}
				  }
			  },
			  {
				label: `${t('button_no')}`,
				id: 'no-cancel',
				onClick: () => handleNoCancel(),
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === false){
						e.preventDefault()
						$('#yes-cancel').trigger('focus');
					  }
					}
				  }
			  }
			],
			
			closeOnEscape: true,
			closeOnClickOutside: false,
			overlayClassName: "delete_overlay"
		});		
	}

	const handleSaveAndExit = async () => {
		if(projectCreationStep === "Source Material Step 1") {
			dispatch(updateDepartment({
				"path": null,
				"applicationVersion": null,
				"id": SelectDepartmentRedux.value,
				"name": SelectDepartmentRedux.label,
				"createdDate": null,
				"systemGroup": false
			}))
			dispatchFinalDataToRedux('status', 'CONFIGURED_BASIC_PROJECT_INFO');
			dispatchFinalDataToRedux('statusCode', 'configured_project_name');
			setInitiateCancelOrSaveExitProject(true);
		}
		if(projectCreationStep === "Source Material Step 2") {
			dispatch(updateProjectContentType(contentTypeRedux));
			dispatchFinalDataToRedux('status', 'CONFIGURED_SOURCE_MATERIALS')
			dispatchFinalDataToRedux('statusCode', 'uploaded_source_materials')
			if (contentTypeRedux === Constants.ELOQUA || contentTypeRedux == Constants.MARKETOREST ||
				contentTypeRedux === Constants.BRIGHTCOVE || contentTypeRedux === Constants.PARDOT ||
				contentTypeRedux === Constants.VIDYARD || contentTypeRedux === Constants.UBERFLIP) {
				let isClone = projectData?.clonedFromProjectId !== null;
				let selectedAssets = getSelectedAssets(contentTypeRedux, selectedTreeData, sourceLanguageRedux, isClone);
				if(isClone){
					const assetTrg = selectedAssets
					?.filter(data => !oldTargetLanguage?.includes(data?.language))
					?.map(data => data);
				dispatch(updateAssets(transformBlankToNull(assetTrg)))
				}else{
					dispatch(updateAssets(transformBlankToNull(selectedAssets)));
				}
				dispatchFinalDataToRedux('assetRules', projectRules);
				let localContacts = []
				dynamicContacts.map(contact => localContacts.push(contact.contact));
				if (contentTypeRedux == Constants.MARKETOREST) {
					dispatchFinalDataToRedux('marketoRestPreviewContactList', localContacts);
				} else if (contentTypeRedux == Constants.ELOQUA) {
					dispatchFinalDataToRedux('eloquaPreviewContactList', localContacts);
				}
			}
			if (projectAssetType === Constants.DYNAMIC) {
				syncProjectRules();
			}
			setInitiateCancelOrSaveExitProject(true);
		}
		if (projectCreationStep === "Language and Reference Material") {
			dispatch(updateSourceLanguage(sourceLanguageRedux.language));
			dispatch(updateTargetLanguage(targetLanguageRedux.map(targetLang => targetLang.language)));
			if (contentTypeRedux === Constants.ELOQUA || contentTypeRedux == Constants.MARKETOREST ||
				contentTypeRedux === Constants.BRIGHTCOVE || contentTypeRedux === Constants.PARDOT || 
				contentTypeRedux === Constants.VIDYARD || contentTypeRedux === Constants.UBERFLIP) {
				let isClone = projectData?.clonedFromProjectId !== null;
				let selectedAssets = getSelectedAssets(contentTypeRedux, selectedTreeData, sourceLanguageRedux, isClone);
				if(isClone){
					const assetTrg = selectedAssets
					?.filter(data => !oldTargetLanguage?.includes(data?.language))
					?.map(data => data);
				dispatch(updateAssets(transformBlankToNull(assetTrg)))
				}else{
					dispatch(updateAssets(transformBlankToNull(selectedAssets)));
				}				
				dispatchFinalDataToRedux('assetRules', projectRules);
				let localContacts = []
				dynamicContacts.map(contact => localContacts.push(contact.contact));
				if (contentTypeRedux == Constants.MARKETOREST) {
					dispatchFinalDataToRedux('marketoRestPreviewContactList', localContacts);
				} else if (contentTypeRedux == Constants.ELOQUA) {
					dispatchFinalDataToRedux('eloquaPreviewContactList', localContacts);
				}
				dispatchFinalDataToRedux('status', 'CONFIGURED_SOURCE_MATERIALS')
				dispatchFinalDataToRedux('statusCode', 'uploaded_source_materials')
			}
			setInitiateCancelOrSaveExitProject(true);
		}
		if (projectCreationStep === "Project Information") {
			let noErrorExists = validateProjectBasicDetails();
			if (!noErrorExists) {
				return;
			}
			dispatchFinalDataToRedux('status', 'CONFIGURED_BASIC_PROJECT_INFO');
			dispatchFinalDataToRedux('statusCode', 'configured_project_name');
			setInitiateCancelOrSaveExitProject(true);
		}

		if (projectCreationStep === "Translation Request") {
			let noErrorExists = validateProjectTranslationRequest();
			if (!noErrorExists) {
				return;
			}
			dispatchFinalDataToRedux('status', 'CONFIGURED_BID_OPTIONS');
			dispatchFinalDataToRedux('statusCode', 'configured_bid_options');
			setInitiateCancelOrSaveExitProject(true);
		}

		if((projectCreationStep === "Project Information" || projectCreationStep === "Translation Request")){
			let noErrorExists = await updateProjectDetails();
			if (!noErrorExists) {
				return;
			}
		}

		if(projectCreationStep === "Workflow Step 1") {
			dispatchFinalDataToRedux('status', 'CONFIGURED_BID_OPTIONS');
			dispatchFinalDataToRedux('statusCode', 'configured_bid_options');
			setInitiateCancelOrSaveExitProject(true);
		}

		if(projectCreationStep === "Workflow Step 2") {
			let clone = Object.assign({}, projectData);
			dispatch(updateProjectInfo(transformBlankToNull(clone)));

			let updatedWorkflowRedux = [...projectWorkflowRedux]
			updatedWorkflowRedux.map((pwresource, pwindex) => {
				let updatedResource = {...pwresource};
				let oldUserGroup = {...updatedResource.userGroup}
				let newUserGroup = {
					id : oldUserGroup.id,
					customer : null,
					createdDate : null,
					name : null,
					deleted : false
				}
				updatedResource.userGroup = newUserGroup;
				updatedWorkflowRedux[pwindex] = updatedResource;
			})
			dispatch(updateProjectWorkflow(transformBlankToNull(updatedWorkflowRedux)));
			dispatchFinalDataToRedux('status', 'CONFIGURED_PROJECT_WORKFLOW')
			dispatchFinalDataToRedux('statusCode', 'configured_project_workflow');
			let followerPayload = [];
			projectFollowersRedux.map((pf) => {
				let follower = {...pf}
				let res = {...follower?.resource};
				let rset = {...res.roleSet}
				rset = follower.roleSet;
				res.roleSet = rset;
				follower.resource = res;
				followerPayload.push({
					path : null,
					applicationVersion : null,
					customerUser : follower?.resource?.customerUser || follower?.resource,
					id : follower.id
				})
			})
			dispatch(updateProjectFollowers(transformBlankToNull(followerPayload)))
			setInitiateCancelOrSaveExitProject(true);
		}
	}

	const saveAndExit = () => {
		$('.btnSave').addClass('btnFocus')
		setTimeout(() => {
		$("#react-confirm-alert").attr({
			'aria-modal': 'true',
			'role': 'dialog',
			'aria-labelledby':"saveProject"
		  });
		  $("h1").attr({
			'id': 'saveProject',
		 });
		}, 200);
		setTimeout(() => {
			$('#cancel-save-and-exit').trigger('focus');
			
			$(".react-confirm-alert-overlay").on("keydown", function (e) {
				if (e.key === Constants.ESCAPE) {
				  if($("button").hasClass("btnFocus")){
					$('.btnFocus').trigger('focus')
					$('.btnSave').removeClass('btnFocus')
				   }
				}
			  });
		}, 600);
		confirmAlert({
			title: translate("project_listing.project_footer"),
			message: <p>{translate("project_listing.assure")}</p>,
			buttons: [
			  {
				label: `${t('button_save_exit')}`,
				id: 'save-and-exit',
				onClick: () => handleSaveAndExit(),
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === true){
						e.preventDefault()
						$('#cancel-save-and-exit').trigger('focus');
					  }
					}
				  }
			  },
			  {
				label: `${t('button_cancel')}`,
				id: 'cancel-save-and-exit',
				onClick: () => handleNoCancel(),
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === false){
						e.preventDefault()
						$('#save-and-exit').trigger('focus');
					  }
					}
				  }
			  }
			],
			closeOnEscape: true,
			closeOnClickOutside: false,
			overlayClassName: "delete_overlay"
		});
	}
    const getMsgWithVendors = function(message, translators) {
            return (
                      <><div className='mar-bot16'>{message}</div>
					 {translators.map(vendor => (<><div className='mar-top6'>{vendor}</div></>))}
                      </>
                   );
    }

    const getLanguageDisplayName = (langName) => {
        let langList = projectData.targetLanguageList?.filter((language) => {
            return language.language == langName;
        });
        return langList?.length > 0 ? langList[0].display : langName;
    }

	const getPopupDetails = () => {		
		getAxiosResponse(APIUrls.INTERNAL_REQUEST(param.id))
		.then((res) => {
			let internal = res.data.data.assigneeUser?.firstName + Constants.SINGLE_WHITESPACE + res.data.data.assigneeUser?.lastName;

			let biddingTranslators = [], bidLessTranslators = [];
			if(isMultiVendorProject) {
            	projectData?.translationPreferences?.map((tp, index) => {
                    let translators = getLanguageDisplayName(tp.language) + " - " +tp.vendors.map(v=>v.name).join(", ");
            	    if(tp.receiveQuotes){
                        biddingTranslators.push(translators);
            	    }else{
            	        bidLessTranslators.push(translators);
            	    }
            	});
            }else if(projectData.projectVendorType === Constants.EXTERNAL_BIDLESS) {
				let translators = bidRequestRedux.preferredVendors.map(v=>v.name).join(", ");
				bidLessTranslators.push(translators);
			}else if(projectData.projectVendorType === Constants.INTERNAL) {
             	bidLessTranslators.push(internal);
            } else if(projectData.projectVendorType === Constants.EXTERNAL) {
                let translators = bidRequestRedux.preferredVendors.map(v=>v.name).join(", ");
                biddingTranslators.push(translators);
			}

			let popupTitle = Constants.BLANK, popupMessage = (<></>);

			if(biddingTranslators.length > 0 && bidLessTranslators.length > 0){
			    popupTitle = `${t('project_title_text.multi_vendor_translator_request')}`;
                popupMessage = (<p>
                                {getMsgWithVendors(`${t('project_confirm_text.bid_vendor_selection')}`, biddingTranslators)}
                                <br/>
                                {getMsgWithVendors(`${t('project_confirm_text.internal_translator_request')}`, bidLessTranslators)}
                                </p>);
			}else if(biddingTranslators.length > 0){
			    popupTitle = `${t('project_title_text.bid_vendor_selection')}`;
                popupMessage = (<p>{getMsgWithVendors(`${t('project_confirm_text.bid_vendor_selection')}`, biddingTranslators)}</p>);
            }else if(bidLessTranslators.length > 0){
                popupTitle = `${t('project_title_text.internal_translator_request')}`;
                popupMessage = (<p>{getMsgWithVendors(`${t('project_confirm_text.internal_translator_request')}`, bidLessTranslators)}</p>);
            }else{
                popupTitle = `${t('project_title_text.machine_translation_request')}`;
                popupMessage = (<p>{getMsgWithVendors(`${t('project_confirm_text.machine_translation_request')}`, [])}</p>);
            }

			showConfirmationAlert({popupTitle, popupMessage});
		})
	}

	const showConfirmationAlert = (popupDetails) => {
		$('.stricy-btn .right-sidebtn:last button').addClass('submitFocusBtn');
		setTimeout(() => {
			$('#accept-submit-for-translation').trigger('focus');
			$(".react-confirm-alert-overlay").on("keydown", function (e) {
				if (e.key === Constants.ESCAPE) {
				  if($("button").hasClass("submitFocusBtn")){
					$('.submitFocusBtn').trigger('focus')
					$('.btn').removeClass('submitFocusBtn')
				   }
				}
			  });
		}, 200);
		setTimeout(() => {
			$("#react-confirm-alert").attr({
				'aria-modal': 'true',
				'role': 'dialog',
				'aria-labelledby':"projectSummary"
			  });
			  $("h1").attr({
				'id': 'projectSummary',
			 });
		}, 200);
		confirmAlert({
			title: popupDetails?.popupTitle,
			message: popupDetails?.popupMessage, 
			buttons: [
			  {
				label: `${t('button_accept')}`,
				id: 'accept-submit-for-translation',
				onClick: () => submitProject({
					"path": null,
					"applicationVersion": null,
					"doLetCloudwordsChoose": false,
					"autoSelectBid": projectData.autoSelectBid,
					"preferredVendors": bidRequestRedux.preferredVendors,
					"winningBidId": null,
					"maxIteration": null
				}),
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === true){
						e.preventDefault()
						$('#cancel-submit-for-translation').trigger('focus');
					  }
					}
				  }
			  },
			  {
				label: `${t('button_cancel')}`,
				id: 'cancel-submit-for-translation',
				onClick: () => cancelProjectSubmission({}),
				onKeyDown : (e) => {
					if(e.key === Constants.TAB){
					  if(e.shiftKey === false){
						e.preventDefault() 
						$('#accept-submit-for-translation').trigger('focus');
					  }
					}
				  }
			  }
			],
			closeOnEscape: true,
			closeOnClickOutside: false,
			overlayClassName: "delete_overlay"
		  });
	}

	const updateProjectDetails = async () => {

		let clone = Object.assign({}, projectData);
		if (projectCreationStep === "Project Information") {
			dispatchFinalDataToRedux('status', 'CONFIGURED_BASIC_PROJECT_INFO');
			dispatchFinalDataToRedux('statusCode', 'configured_project_name');
			clone.status = "CONFIGURED_BASIC_PROJECT_INFO";
			clone.statusCode = "configured_project_name";
		} else if (projectCreationStep === "Translation Request") {
			dispatchFinalDataToRedux('status', 'CONFIGURED_BID_OPTIONS');
			dispatchFinalDataToRedux('statusCode', 'configured_bid_options');
			clone.status = "CONFIGURED_BID_OPTIONS";
			clone.statusCode = "configured_bid_options";
		}
		 delete clone?.targetLanguageList
		 let newProjectData={...clone}
		 if(newProjectData?.bidDueDate){
			newProjectData={...newProjectData,'bidDueDate':newProjectData?.bidDueDate?.utcTimestamp?getTimeStamp(newProjectData?.bidDueDate?.utcTimestamp):timeStamp(newProjectData?.bidDueDate?.dateWithTime?newProjectData?.bidDueDate?.dateWithTime:newProjectData?.bidDueDate,userTimeZone)}
		   }
		   if(newProjectData?.deliveryDueDate){
			   newProjectData={...newProjectData,'deliveryDueDate':newProjectData?.deliveryDueDate?.utcTimestamp? getTimeStamp(newProjectData?.deliveryDueDate?.utcTimestamp):timeStamp(newProjectData?.deliveryDueDate?.dateWithTime?newProjectData?.deliveryDueDate?.dateWithTime:newProjectData?.deliveryDueDate,userTimeZone)}
		   }
		   if(newProjectData?.bidSelectDeadlineDate){
			   newProjectData={...newProjectData,'bidSelectDeadlineDate':newProjectData?.bidSelectDeadlineDate?.utcTimestamp?getTimeStamp(newProjectData?.bidSelectDeadlineDate?.utcTimestamp):timeStamp(newProjectData?.bidSelectDeadlineDate?.dateWithTime?newProjectData?.bidSelectDeadlineDate?.dateWithTime:newProjectData?.bidSelectDeadlineDate,userTimeZone)}
		   }
		const result = await putAxiosResponse(APIUrls.PROJECT(param.id), transformBlankToNull(newProjectData))
		.then(res => {
			setEligibleForPutCall(false);
			if (res.data?.data?.statusCodeValue === 200 || res?.data?.data?.status === 'success' || res?.data?.data?.resource !==undefined) {
				let projectResource = transformBlankToNull(res?.data?.data?.resource?.projectResource);
				delete projectResource["projectFollowers"];
				//deleted  this key as it was giving 400 
				if(projectResource["workspace"] && projectResource["workspace"]['workspaceMembers']){
				delete projectResource["workspace"]['workspaceMembers']
				}
				const targetLanguages = res.data.data.displayName[0].targetLanguages;
				const inProgressProjectConfigs = JSON.parse(localStorage.getItem('inProgressProjectConfigs'));
				const inprogressLanguageSet = new Set(inProgressProjectConfigs?.map(config => config.language));
				if(contentTypeRedux === Constants.ELOQUA && targetLanguages !==undefined && inprogressLanguageSet.size > 0){
					const newTargetLanguages = targetLanguages.filter(newLang => {
						if(!inprogressLanguageSet.has(newLang.language)){
							return newLang;
						}
					});
					const filteredTargetLanguages = projectResource.targetLanguages.filter(targetLang => {
						if(!inprogressLanguageSet.has(targetLang.language)){
							return targetLang;
						}
					});
					dispatch(updateCreateProjectTargetLanguage(newTargetLanguages));
					projectResource.targetLanguages = filteredTargetLanguages;
					projectResource.targetLanguageList = newTargetLanguages;
				}
				else
				{
					projectResource.targetLanguageList = targetLanguages;
				}
				projectResource.intendedUse = {"id":projectResource.intendedUse.id,"name":projectResource.intendedUse.name};
                projectResource.translationType = projectData.translationType;
				setUpdatedProjectInfo(projectResource);

				if (projectCreationStep === "Translation Request") {
					if (projectData?.projectVendorType === 'EXTERNAL' || projectData?.projectVendorType === 'EXTERNAL_BIDLESS') {
						putAxiosResponse(APIUrls.BID_REQUEST_BY_ID(param.id), bidRequest)
							.then(() => {
								return true;
							})
							.catch(() => {
								return false;
							});
					}
					else if (projectData?.projectVendorType === 'INTERNAL') {
						putAxiosResponse(APIUrls.INTERNAL_REQUEST(param.id), projectData?.assignment)
							.then(() => {
								return true;
							})
							.catch(() => {
								return false;

							});
					}
				}
				return true
			}
			else{				
				let body=res?.data?.data?.body;
				if( body && body.errors!==undefined){
					if(body.errors['deliveryDueDate']!==undefined){
						setProjectInfoValidationToRedux('deliveryDueDate', body.errors['deliveryDueDate'])
					}
					if(body.errors['bidDueDate']!==undefined){
						setProjectInfoValidationToRedux('bidDueDate', body.errors['bidDueDate'])
					}
					if(body.errors['purchaseOrder']!==undefined) {
						setProjectInfoValidationToRedux('purchaseOrder', body.errors['purchaseOrder'])
					}
				}
				return false;

			}
		}).catch(err => {
			setEligibleForPutCall(false);
			return false;
		});
		return result;

	}

	const validateWorkflowAndFollowers = () => {
		let status = false;
		projectWorkflowRedux?.forEach((projectWorkflow) => {
			projectWorkflow.steps.forEach((step) => {
				step.phases.forEach((phase) => {
					if(phase.phaseType.code === Constants.PHASE_TYPE_PE && (phase.dueDate === "" || phase.assigneeVendor === "")){
						status = true;
						return;
					}
					if(phase.assigneeType.display === "Internal" && (phase.assigneeUsers.length === 0 || phase.dueDate.length === 0)) {
						status = true;
						return;
					}
				})
			})
		})
		const uniqueArray = targetLanguageRedux.filter((item, index, self) => {
			return self.findIndex((otherItem) => (otherItem.code === item.code)) === index;
		});
		if(projectWorkflowRedux?.length !== uniqueArray.length) {
			status = true;
		}
		return status;
	}


	const selectedTreeLanguageStatus=()=>{
		let status=false; 
		if(selectedTreeData && selectedTreeData?.length > 0){
		  selectedTreeData.forEach(data=>{
			   if(data?.targetLanguages===undefined || data.targetLanguages===null ||  data.targetLanguages && data.targetLanguages.length ==0){
				status=true;
				return 
			   }
		  })
		}
		return status
}

  const checkValidationOldLanguage=()=>{
	const assetLanguageMap = new Map();
	   selectedTreeData.forEach(treeData=>{
		assetLanguageMap.set(treeData?.externalId,true)
		    if(oldTargetLanguage && oldTargetLanguage?.length > 0 && oldTargetLanguage?.findIndex(data=>data?.externalId===treeData?.externalId) !==-1){
			let oldTargetLanguageIndex=oldTargetLanguage?.findIndex(data=>data?.externalId===treeData?.externalId);
			let language=oldTargetLanguage[oldTargetLanguageIndex].language
				treeData?.targetLanguages?.forEach(lang=>{
					//If any new language is added
                        if(!language?.includes(lang?.language)){
							assetLanguageMap.set(treeData?.externalId,false)
						}
				})
			}
	   })
	let finalStatus=false;
	   assetLanguageMap.forEach((values, keys) => {
		if(values===true){
			finalStatus=true;
		}
	});
	   return finalStatus;
  }

	const isRuleOkForDynamicAssets = () => {
		let isAllOk = false;
		if (projectAssetType === Constants.DYNAMIC) {
			let targetLangs = projectRules.flatMap(rule => (rule.ruleValues.filter(rv=>rv.language !== null).map(ruleValue => (ruleValue.language))));
			if (targetLangs?.length > 1 && targetLangs.includes(sourceLanguageRedux?.language)) {
				isAllOk = true;
			}
		} else {
			isAllOk = true;
		}
		return isAllOk;
	}

	let disableNextButton = (projectCreationStep === "Source Material Step 1" && SelectDepartmentRedux?.value === undefined) ||
	(projectCreationStep === "Source Material Step 2" && source.length === 0 && selectedTreeData?.length === 0 && (asyncAssetUploadInfo?.pendingFiles && Object.keys(asyncAssetUploadInfo?.pendingFiles)?.length === 0)) ||

	(projectCreationStep === "Language and Reference Material" && (sourceLanguageRedux !== undefined && (Object.keys(sourceLanguageRedux).length === 0 || targetLanguageRedux.length === 0 || !isRuleOkForDynamicAssets()))) ||

	(projectCreationStep === "Workflow Step 2" && validateWorkflowAndFollowers() )||

	(projectCreationStep === "Project Information" && 
	( projectData.name==='' || projectData.intendedUse===null  || projectData.intendedUse?.id === undefined || 
	(projectData?.workspace?.id ===-1 && (projectData?.workspace?.name==undefined || projectData?.workspace?.name=='' || projectData?.workspace?.dueDate===null) ) || 
		( projectInfoConfiguration.updateGlossaryPermission=== true && (projectData?.projectUpdateGlossary?.generalGlossary===undefined || 
			projectData?.projectUpdateGlossary?.generalGlossary===null  || projectData?.projectUpdateGlossary?.termStatusOnCompletion===null || 
			projectData?.projectUpdateGlossary?.termStatusOnCompletion===undefined ))))|| 
			(projectCreationStep === "Project Summary"  && !asyncAssetUploadInfo.canSubmitTranslation) ||
			(projectCreationStep === "Project Summary"  && ((asyncAssetUploadInfo?.pendingFiles && Object.keys(asyncAssetUploadInfo?.pendingFiles)?.length !== 0) || asyncAssetUploadInfo?.inProgressFiles?.length !== 0))

	if(projectCreationStep === "Translation Request"){
	    if(isMultiVendorProject){
	        disableNextButton=false; //TODO : add data validation
        } else if(!projectData.projectVendorType || errorData?.purchaseOrder?.length > 0) {
			disableNextButton=true
		} else if(projectData.projectVendorType === 'EXTERNAL'){
            if((projectData?.deliveryDueDateExceeded === true) || (projectData.deliveryDueDate===null) || (projectData.bidDueDate===null) ||  !(bidRequestRedux?.preferredVendors && Object.keys(bidRequestRedux?.preferredVendors).length > 0) 
			|| (new Date(projectData.deliveryDueDate).getTime()===new Date(projectData.bidDueDate).getTime()) || (custBootstrapDataRedux?.features?.INTERNATIONAL_CURRENCY && projectData?.currency === "")
			
			){
                disableNextButton=true
            }else{
                disableNextButton=false
            }
        }else if(projectData.projectVendorType === 'EXTERNAL_BIDLESS'){
            if((projectData?.deliveryDueDateExceeded === true) || projectData.deliveryDueDate===null || !(bidRequestRedux?.preferredVendors && Object.keys(bidRequestRedux?.preferredVendors).length > 0)){
              disableNextButton=true
            }else{
                disableNextButton=false
            }
      }else if(projectData.projectVendorType === 'INTERNAL'){
            if((projectData?.deliveryDueDateExceeded === true) || (projectData.deliveryDueDate===null || projectData?.assignment===null)){
              disableNextButton=true
            }else{
                disableNextButton=false
            }
      }else if(projectData.projectVendorType === 'MACHINE_TRANSLATION'){
        if((projectData?.deliveryDueDateExceeded === true) || projectData.deliveryDueDate===null ||  projectData.translationEngineType===null){
            disableNextButton=true
        }else{
            disableNextButton=false
        }
      }      
    }else{
         if(projectCreationStep !== "Source Material Step 2" && projectCreationStep !=="Upload Image Step" && selectedTreeLanguageStatus() && projectAssetType !== Constants.DYNAMIC){
            disableNextButton=true
		 }if(projectCreationStep !== "Source Material Step 2" && projectCreationStep !=="Upload Image Step" && checkValidationOldLanguage()){
            if(projectData?.clonedFromProjectId !== null && contentTypeRedux === Constants.ELOQUA && projectAssetType !== Constants.DYNAMIC){
			disableNextButton=true
			}
		 }
	}
	


	return (
		<>
		{(message !== undefined && message !== Constants.BLANK)?<SuccessMessage message={message}/>:Constants.BLANK}
		<div className="stricy-btn flex flex-center project-footer-stricky">
			<div className="left flex">
				<div><button className={showCancelAndSaveExit ? "btn btnSave" : "btn hide btnSave"} onClick={saveAndExit} disabled={disableNextButton}>Save and Exit Project</button></div>
				<div><button className={showCancelAndSaveExit ? "btn btnCancel" : "btn hide btnCancel"} onClick={cancelProject}>Cancel Project</button></div>
			</div>
			<div className="left right-sidebtn flex">
				{projectCreationStep !== "Source Material Step 1" && <div><button className="btn-default" onClick={back}>Back</button></div>}
				{/* {projectCreationStep === "Project Summary" ? 
					<div><button className="btn-default">Submit for Review</button></div>
				: ""} */}
				<div>
					<button
					 id="goNext"
					 className={showNext ? "btn" : "btn hide"}
					 onClick={next}
					 disabled={disableNextButton}
					 createproject-tour="next-steps"
					>
						{projectCreationStep === "Project Summary" ? 'Submit for Translation' : 'Next'}
					</button>
				</div>
			</div>
		</div>
		</>
	)
}
